<template>
  <v-window-item value="address">
    <v-card-text>
      <v-card variant="outlined" class="mb-4">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-home</v-icon>
          Present Address
        </v-card-title>
        <v-card-text>
          <v-card variant="tonal" class="py-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item
                  prepend-icon="mdi-map-marker-outline"
                  title="Road/House/Flat"
                  :subtitle="(userAddressInfoData?.present_village_road_house_flat) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-home-city-outline"
                    title="Village/Area"
                    :subtitle="(userAddressInfoData?.present_village_house) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-mailbox-outline"
                    title="Post Office"
                    :subtitle="(userAddressInfoData?.present_post_office) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-mailbox-up-outline"
                    title="Post Code"
                    :subtitle="(userAddressInfoData?.present_post_code) || 'N/A'"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-list-item
                  prepend-icon="mdi-map-marker-radius-outline"
                  title="Thana/Upazilla"
                  :subtitle="(userAddressInfoData?.present_thana_upazilla) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-map-outline"
                    title="District"
                    :subtitle="(userAddressInfoData?.present_district) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-map-marker-radius"
                    title="Division"
                    :subtitle="(userAddressInfoData?.present_division) || 'N/A'"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card variant="outlined">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-map-marker</v-icon>
          Permanent Address
        </v-card-title>
        <v-card-text>
          <v-card variant="tonal" class="py-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item
                  prepend-icon="mdi-map-marker-outline"
                  title="Road/House/Flat"
                  :subtitle="(userAddressInfoData?.permanent_village_road_house_flat) || 'N/A'"
                />
                <v-list-item
                    prepend-icon="mdi-home-city-outline"
                    title="Village/Area"
                    :subtitle="(userAddressInfoData?.permanent_village_house) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-mailbox-outline"
                    title="Post Office"
                    :subtitle="(userAddressInfoData?.permanent_post_office) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-mailbox-up-outline"
                    title="Post Code"
                    :subtitle="(userAddressInfoData?.permanent_post_code) || 'N/A'"
                />
              </v-col>

              <v-col>
                <v-list-item
                    prepend-icon="mdi-map-marker-radius-outline"
                    title="Thana/Upazilla"
                    :subtitle="(userAddressInfoData?.permanent_thana_upazilla) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-map-outline"
                    title="District"
                    :subtitle="(userAddressInfoData?.permanent_district) || 'N/A'"
                />
                <v-list-item
                    prepend-icon="mdi-map-marker-radius"
                    title="Division"
                    :subtitle="(userAddressInfoData?.permanent_division) || 'N/A'"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-window-item>
</template>

<script setup>
defineProps({
  userAddressInfoData: {
    type: Object,
    default: () => ({})
  }
})
</script>
